import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../../../../common/global/helpers';
import Button from '../../../../../../common/widgets/Button';
import Dialog from '../../../../../../common/widgets/Dialog';
import { resources } from '../../../../resources/resources';
import { merchantAccountsService } from '../../../../services/merchant-accounts';
import ModalAlertImg from '../../../../../../common/assets/images/merchants/modal-attention.svg';

interface InactivateAccountDialogProps {
  accountId: number;
  fullName: string;
  closeDialog: () => void;
  onUserInactivated: () => void;
}

export const InactivateAccountDialog = (
  props: InactivateAccountDialogProps,
) => {
  const { accountId, fullName, closeDialog, onUserInactivated } = props;
  const { t: translate } = useTranslation();
  const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false);

  const onSaveClick = async () => {
    setIsSaveLoading(true);
    const resp = await merchantAccountsService.inactivateAccount(accountId);
    setIsSaveLoading(false);

    if (resp.hasErrors) {
      showErrorToast(translate(resources.errors.generic));
    } else {
      onUserInactivated();
    }
  };

  return (
    <Dialog closeDialog={closeDialog} showCloseIcon className="dialog-m">
      <div className="dialog-content">
        <div className="dialog-image m-dialog-img">
          <img
            src={ModalAlertImg}
            alt={translate(resources.accounts.dialog.delete.title)}
          />
        </div>
        <div className="dialog-title">
          {translate(resources.accounts.dialog.delete.title)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.accounts.dialog.delete.info, { 0: fullName })}
        </div>
      </div>
      <div className="dialog-actions horizontal-auto">
        <Button
          className="btn btn-outline"
          onClick={closeDialog}
          disabled={isSaveLoading}
        >
          <span className="btn-text">{translate(resources.abort)}</span>
        </Button>
        <Button
          className="btn btn-solid"
          onClick={onSaveClick}
          loading={isSaveLoading}
        >
          <span className="btn-text">
            {translate(resources.accounts.dialog.delete.button)}
          </span>
        </Button>
      </div>
    </Dialog>
  );
};
